import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_table_graph = _resolveComponent("table-graph");
  const _component_error_wrapper = _resolveComponent("error-wrapper");
  return _openBlock(), _createBlock(_component_error_wrapper, {
    showError: $data.showError,
    onRetry: $options.retry
  }, {
    default: _withCtx(() => [_createVNode(_component_table_graph, {
      onSortTable: $options.sortTable,
      graphId: $data.graphId,
      graphTitle: $options.graphTitle,
      graphHeaders: $data.graphHeaders,
      tableLoading: $options.graphLoading,
      positions: _ctx.graph,
      minMax: $data.minMax,
      description: $data.graphDescription,
      sortBy: $data.sortBy,
      sortDirection: $data.sortDirection,
      onPage: $options.handlePage,
      currentPage: $data.currentPage,
      pageSize: $data.pageSize,
      totalCount: $data.totalPositionsCount,
      dataWidths: $data.totalWidths,
      setStriped: true,
      pageRenderedLoading: $data.pageRenderedLoading
    }, null, 8, ["onSortTable", "graphId", "graphTitle", "graphHeaders", "tableLoading", "positions", "minMax", "description", "sortBy", "sortDirection", "onPage", "currentPage", "pageSize", "totalCount", "dataWidths", "pageRenderedLoading"])]),
    _: 1
  }, 8, ["showError", "onRetry"]);
}